if (!customElements.get('notify-me-popup')) {
    class NotifyMePopup extends HTMLElement {
        constructor() {
            super();
            this.form = this.querySelector('.back-in-stock');
            this.errorWrapper = this.querySelector('.back-in-stock-error');
            this.setupEventListeners();
        }

        setupEventListeners() {
            const closeButton = this.querySelector('.notify-me-popup-close');
            if (closeButton) {
                closeButton.addEventListener('click', () => {
                    this.hide();
                });
            }

            const popup = this.querySelector('.notify-me-popup');
            if (popup) {
                popup.addEventListener('click', (event) => {
                    if (event.target === popup) {
                        this.hide();
                    }
                });
            }

            // Handle form submission
            if (this.form) {
                this.form.addEventListener('submit', this.handleSubmit.bind(this));
            }

            document.addEventListener('keydown', (event) => {
                if (event.key === 'Escape' && this.isVisible()) {
                    this.hide();
                }
            });
        }

        async handleSubmit(event) {
            event.preventDefault();
            const formData = Object.fromEntries(new FormData(this.form));
            
            try {
                const response = await this.submitBackInStockRequest(formData);
                
                if (response.status === 202) {
                    this.handleSuccess(formData.email);
                } else {
                    const data = await response.json();
                    this.handleError(data);
                }
            } catch (error) {
                console.error('Submission error:', error);
                this.showError('An unexpected error occurred. Please try again.');
            }
        }

        async submitBackInStockRequest({ email, variant }) {
            return fetch(this.form.action, {
                method: 'POST',
                headers: {
                    accept: 'application/vnd.api+json',
                    revision: '2024-10-15',
                    'content-type': 'application/vnd.api+json'
                },
                body: JSON.stringify({
                    data: {
                        type: 'back-in-stock-subscription',
                        attributes: {
                            profile: {
                                data: {
                                    type: 'profile',
                                    attributes: { email }
                                }
                            },
                            channels: ['EMAIL']
                        },
                        relationships: {
                            variant: {
                                data: {
                                    type: 'catalog-variant',
                                    id: `$shopify:::$default:::${variant}`
                                }
                            }
                        }
                    }
                })
            });
        }

        handleSuccess(email) {
            // Hide the form and show success message
            this.form.style.display = 'none';
            
            // Create and show success message
            const successMessage = document.createElement('div');
            successMessage.className = 'back-in-stock-success';
            successMessage.style.display = 'block';
            successMessage.innerHTML = `
                <h3>You're on the List!</h3>
                <p>You'll receive an email when the product is back in stock in the size you selected!</p>
            `;
            
            this.form.parentNode.appendChild(successMessage);
        }

        handleError(response) {
            if (response?.errors?.[0]?.detail) {
                this.showError(response.errors[0].detail);
            } else {
                this.showError('Something went wrong. Please try again.');
            }
        }

        showError(message) {
            if (this.errorWrapper) {
                this.errorWrapper.innerHTML = message;
                this.errorWrapper.classList.remove('hidden');
            }
        }

        show() {
            this.style.display = 'block';
            document.body.style.overflow = 'hidden';
        }

        hide() {
            this.style.display = 'none';
            document.body.style.overflow = '';
            
            // Reset form state when hiding
            if (this.form) {
                this.form.style.display = 'block';
                this.form.reset();
            }
            
            // Remove success message if it exists
            const successMessage = this.querySelector('.back-in-stock-success');
            if (successMessage) {
                successMessage.remove();
            }
            
            // Clear any error messages
            if (this.errorWrapper) {
                this.errorWrapper.classList.add('hidden');
                this.errorWrapper.innerHTML = '';
            }
        }

        isVisible() {
            return this.style.display === 'block';
        }

        connectedCallback() {
            this.style.display = 'none';
        }
    }

    customElements.define('notify-me-popup', NotifyMePopup);
}
